"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenameProjectItemPayloadFactoryFromJs = exports.RenameProjectItemPayloadFactory = void 0;
const immutable_1 = require("immutable");
exports.RenameProjectItemPayloadFactory = (0, immutable_1.Record)({
    extension: null,
    itemId: null,
    name: null,
    ide: null,
    projectSecretKey: null
});
const RenameProjectItemPayloadFactoryFromJs = function (data) {
    return (0, exports.RenameProjectItemPayloadFactory)(data);
};
exports.RenameProjectItemPayloadFactoryFromJs = RenameProjectItemPayloadFactoryFromJs;
//# sourceMappingURL=IRenameProjectItemPayload.js.map